import { Code2 } from "lucide-react";

import type { TIconProps } from "./types";

export const Code = (props: TIconProps): JSX.Element => (
  <Code2
    stroke="var(--fill1)"
    style={{ strokeWidth: "calc(1.5 + var(--nav-glyph-bold, 0) * 1.2)" }}
    {...props}
  />
);
